/// <amd-module name="Pipeline/Analytics/PipelineOutcome/PassRateTrendCard/MockData" />
import * as Utils_Date from "Analytics/Shared/Utils/DateUtils";
import * as DateUtils from "Analytics/Shared/Utils/DateUtils";
import { IPipelineOutcomeData } from "Pipeline/Analytics/Common/Types";

export function getMockPipelineOutcomeData(): IPipelineOutcomeData {
    const date1 = Utils_Date.addDays(Utils_Date.shiftToUTC(DateUtils.getDate()), -5, true);
    const date2 = Utils_Date.addDays(Utils_Date.shiftToUTC(DateUtils.getDate()), -2, true);
    return {
        pipelineOutcomePassRateData: {
            passPercentage: 80,
            failedCount: 10,
            totalCount: 50,
            passedCount: 40
        },
        trendChartData: {
            primaryChartData: {},
            secondaryChartData: [
                { date: Utils_Date.convertDateToDateString(date1), aggrValue: 70 },
                { date: Utils_Date.convertDateToDateString(date2), aggrValue: 90 }
            ]
        }
    };
}
